import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
    Calendar,
    Slider,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, timeConversion, getDateBetween, showDate } from '../../../utils';
import TimePairsSelect from './TimePairsSelect.js';
import PvcRatio from './PvcRatio.js'
import {
    getList,
    getTaskId,
    createAddShowAction,
    submitToMD,
    insertToMD,
    getProvinceList,
    getLabelList,
    getCurveList,
    getPrimaryAndOtherScript,
    getClusterList,
    getOutTaskCategoryList,
    getGroupList,
    getAgentsAndAreas,
    getUserList,
    getMonitorList,
} from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
import BehaviourMask from './changeBehaviour';

let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
let listData = [];

class AddTask extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            role: user.role || 0,
            filtration: [],
            pvToUvRatio: 100,
            forceWait: 30,
            ipReusedTimes: 1,
            activeProportion: 80,
            shellProportion: 80,
            waitTimeout: 40,
            overflowRate: 20,
            realTimeIvt: 0,
            // taskPosition: 'DEFAULT',
            engine: 'PHANTOMJS',
            taskSource: 'ifengad',
            beginTime: '09:30',
            endTime: '23:59',
            deviceIdReusedTimes: 3,
            ipInterval: 0,
            ipUnitReuseTimes: 0,
            behaviourData: '',
            editBehavior: false,
            deviceInfo: 'DEFAULT',
            androidRatio: 70,
            irCountExcept: 1,
            ipRange: 0,
            taskType: 'CLICK',
            ipDiffByTaskOrEid: 0,
            deviceIdDiffByTaskOrEid: 0,
        };
    }
    componentDidMount() {
        //   this.props.getProvinceList();
        //   this.props.getScripts();
        //   this.props.getClusterList();
        //    this.props.getGroupList();
        //    this.props.getAgentsAndAreas();
        //    this.props.getLabelList();
        //    this.props.getCurveList();
        //   this.props.getMonitorList();
    }
    async handleChange(value) {
        if (value == 'CLICK') {
            await this.setState({
                ...this.state,
                ipReusedTimes: 1,
                waitTimeout: 40,
                pvToUvRatio: 100,
                forceWait: 30,
                taskType: value,
            });
        } else {
            await this.setState({
                ...this.state,
                ipReusedTimes: 30,
                waitTimeout: 5,
                pvToUvRatio: 50,
                forceWait: 0,
                taskType: value,
            });
        }
    }
    async handleChangeDeviceInfo(value) {
        if (value == 'DEFAULT') {
            await this.setState({
                ...this.state,
                deviceInfo: value,
                androidRatio: 70,
            });
        } else if (value == 'ANDROID') {
            await this.setState({
                ...this.state,
                deviceInfo: value,
                androidRatio: 100,
            });
        } else {
            await this.setState({
                ...this.state,
                deviceInfo: value,
                androidRatio: 0,
            });
        }
    }
    async handleEngine(value) {
        await this.setState({
            engine: value,
        });
    }
    // changeTaskPosition = value => {
    //     console.log(value);
    //     if (this.state.role == 1) {
    //         this.setState({
    //             ...this.state,
    //             taskPosition: value,
    //         });
    //     }
    // };
    changeFlow = e => {
        this.setState({
            ...this.state,
            overflowRate: e.target.value,
        });
    };
    changeTaskSource = e => {
        if (e.target.value == 'accurateOperations') {
            this.setState({
                ...this.state,
                beginTime: '00:00',
                endTime: '23:59',
                taskSource: e.target.value,
            });
        } else {
            this.setState({
                ...this.state,
                beginTime: '09:30',
                endTime: '23:59',
                taskSource: e.target.value,
            });
        }
    };
    formatData = (oldData, data) => {
        for (var i = 0; i < oldData.length; i++) {
            let item = oldData[i];
            if (item.taskId == this.props.parentId) {
                item.subTasks.push(data);
                break;
            } else {
                this.formatData(item.subTasks, data);
            }
        }
        return oldData;
    };
    changeAddHide = () => {
        this.props.changeAddStatus(false);
        this.setState({
            filtration: [],
            behaviourData: '',
            editBehavior: false,
        });
    };
    async selectData(value) {
        console.log(value);
        const data = value.format('YYYY-MM-DD');
        let repate = false;
        for (let i = 0; i < dataArray.length; i++) {
            if (dataArray[i] == data) {
                repate = true;
                // alert('已选择');
                this.removeData(i);
                return;
            }
            repate = false;
        }

        if (!repate) {
            dataArray.push(value.format('YYYY-MM-DD'));
            this.setState({
                ...this.state,
                filtration: dataArray,
            });
        }
    }
    removeData = index => {
        dataArray = dataArray.filter((v, k) => {
            return index != k;
        });
        this.setState({
            ...this.state,
            filtration: dataArray,
        });
    };

    dateCellRender = value => {
        return this.state.filtration.map(
            item =>
                item == value.format('YYYY-MM-DD') ? (
                    <div
                        style={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            width: 22,
                            height: 22,
                            lineHeight: '22px',
                            backgroundColor: '#108ee9',
                            color: '#fff',
                            borderRadius: '4px',
                        }}>
                        {showDate(item)}
                    </div>
                ) : null,
        );
    };
    async submit(i) {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    fieldsValue.filtration = this.state.filtration;
                    fieldsValue.behaviourData = this.state.behaviourData;
                    // fieldsValue.beginTime = fieldsValue.beginTime.format('HH:mm');
                    // fieldsValue.endTime = fieldsValue.endTime.format('HH:mm');
                    // fieldsValue.timePairs = [
                    //     {
                    //         beginTime: fieldsValue.beginTime.replace(':', ''),
                    //         endTime: fieldsValue.endTime.replace(':', ''),
                    //     },
                    // ];
                    fieldsValue.actions = [];
                    fieldsValue.subTasks = [];
                    fieldsValue.status = 0;
                    fieldsValue.overflowRate =
                        this.state.overflowRate == 40
                            ? parseInt(fieldsValue.overflow)
                            : parseInt(this.state.overflowRate);
                    fieldsValue.api =
                        this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike'
                            ? fieldsValue.api
                            : '';
                    fieldsValue.overflow =
                        this.state.overflowRate == 40
                            ? parseInt((fieldsValue.targetPv * fieldsValue.overflow) / 100)
                            : parseInt((fieldsValue.targetPv * this.state.overflowRate) / 100);
                    // fieldsValue.createTime = Date.parse(new Date());
                    fieldsValue.iosRatio = 100 - fieldsValue.androidRatio;
                    fieldsValue.createTime = new Date();
                    if (this.state.filtration.length <= 0) {
                        alert('请选择启用时间');
                        return;
                    }
                    // if (this.state.taskPosition != 'DEFAULT' && fieldsValue.scriptPath === undefined) {
                    //     message.error('广告位置不是默认时,脚本路径为必填项');
                    //     return;
                    // }
                    if (this.props.addType == 1) {
                        //添加任务
                        fieldsValue.parentId = '0';
                        await this.props.toInsert(fieldsValue);
                    }
                    if (this.props.addType == 2) {
                        //添加子任务
                        fieldsValue.parentId = this.props.parentId;
                        fieldsValue.taskId = this.props.taskId;
                        let treeRoot = [];
                        treeRoot.push(this.props.root);
                        treeRoot = this.formatData(treeRoot, fieldsValue);
                        await this.props.toSubmit(treeRoot[0]);
                    }
                    await this.props.form.resetFields();
                    dataArray = [];
                    await this.setState({
                        ...this.state,
                        filtration: [],
                        behaviourData: '',
                        editBehavior: false,
                    });
                    await this.props.getList(this.props.listState);
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    }
    showBehaviourEdit = () => {
        // 显示编辑行为数据的层
        if (this.state.behaviourData) {
            this.setState({ editBehavior: true });
        } else {
            message.error('转换的数据为空');
        }
    };
    hideBehaviorMask = () => {
        this.setState({ editBehavior: false });
    };
    changeBehaviourData = e => {
        this.setState({ behaviourData: e.target.value });
    };
    changeEditInfo = data => {
        console.log(data);
        this.setState(data);
    };
    render() {
        const { getFieldDecorator, onPanelChange } = this.props.form;
        const {
            accountList,
            moniterNameList,
            topId,
            addType,
            addStatus,
            provinceList,
            labelList,
            curveList,
            primaryScripts,
            otherScripts,
            clusterList,
            outTaskCategoryList = [],
            groupList,
            agents,
            userList,
        } = this.props;
        const marks = {
            0: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: {
                style: {
                    color: '#f50',
                },
                label: <strong>10</strong>,
            },
        };
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        const { editBehavior, taskType } = this.state;
        return (
            <div>
                <Modal
                    title={addType == 1 ? '添加任务' : '添加子任务'}
                    visible={addStatus}
                    onCancel={() => this.changeAddHide()}
                    onOk={() => {
                        this.submit();
                    }}>
                    <Form>
                        <FormItem {...formItemLayout} label="订单名称">
                            {getFieldDecorator('taskDescription', {
                                initialValue: this.props.listState.defaultTaskDescription,
                                rules: [
                                    {
                                        type: 'string',
                                        required: true,
                                        message: '请输入订单名称',
                                    },
                                ],
                            })(<TextArea />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务名称">
                            {getFieldDecorator('taskName', {
                                rules: [
                                    {
                                        type: 'string',
                                        required: true,
                                        message: '请输入任务名称',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务类型">
                            {getFieldDecorator('taskType', {
                                initialValue: this.state.taskType,
                                rules: [{ required: true, message: '请选择类型' }],
                            })(
                                <Select onChange={this.handleChange.bind(this)}>
                                    <Option value="EV">曝光</Option>
                                    <Option value="CLICK">点击</Option>
                                    <Option value="APPLAUNCH">APP拉起</Option>
                                    <Option value="COMBINE_EV_CLICK">合并</Option>
                                    <Option value="APP_RETAIN">注册留存</Option>
                                    <Option value="RE">注册</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {taskType === 'APP_RETAIN' || taskType === 'APPLAUNCH' ? (
                            <div>
                                <FormItem {...formItemLayout} label="账号信息">
                                    {getFieldDecorator('accountKey', {})(
                                        <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                            {accountList.map((item, index) => {
                                                return (
                                                    <Option key={index} value={item.redisKey}>
                                                        {item.accountName}
                                                    </Option>
                                                );
                                            })}
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否打码">
                                    {getFieldDecorator('needHitCode')(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否接码">
                                    {getFieldDecorator('needReceiveCode')(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="代理模式">
                                    {getFieldDecorator('proxyModel')(
                                        <Select>
                                            <Option value={0}>VPN</Option>
                                            <Option value={1}>SYSPOXY</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                            </div>
                        ) : (
                            ''
                        )}
                        <FormItem {...formItemLayout} label="外部任务分类">
                            {getFieldDecorator('outType')(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {outTaskCategoryList.map((outTaskCategory, index) => {
                                        return (
                                            <Option
                                                key={outTaskCategory.categoryId}
                                                title={outTaskCategory.name}
                                                value={outTaskCategory.categoryId}>
                                                {outTaskCategory.name}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                                // <Select>
                                //     <Option value={1}>F+</Option>
                                // </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="广告系统id">
                            {getFieldDecorator('eId')(<Input />)}
                        </FormItem>
                        {taskType === 'COMBINE_EV_CLICK' ? (
                            <div>
                                <FormItem {...formItemLayout} label="点击目标量">
                                    {getFieldDecorator('clickTargetPv', {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入点击目标量',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否点击任务">
                                    {getFieldDecorator('isEvClick', {
                                        rules: [{ required: true, message: '请选择' }],
                                    })(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="ip利用次数">
                                    {getFieldDecorator('clickIpReusedTimes', {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入ip利用次数',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="点击等待时长">
                                    {getFieldDecorator('clickWaitTimeout', {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入点击等待时长',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                            </div>
                        ) : (
                            ''
                        )}

                        <FormItem {...formItemLayout} label="线索信息">
                            {getFieldDecorator('clue', {
                                rules: [
                                    {
                                        required: false,
                                        message: '输入线索信息',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="APP唤醒方式">
                            {getFieldDecorator('appWake')(
                                <Select>
                                    <Option value={0}>h5</Option>
                                    <Option value={1}>Dpl拉起</Option>
                                    <Option value={2}>Ulk拉起</Option>
                                    {/* <Option value="0">h5</Option>
                                    <Option value="1">Dpl拉起</Option> */}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="指定设备号前缀">
                            {getFieldDecorator('deviceRedisKeyPreFix')(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="UA标识">
                            {getFieldDecorator('uaFlag')(
                                <Select>
                                    <Option value={1}>ZhiHu</Option>
                                    <Option value={2}>BV</Option>
                                    <Option value={3}>YK</Option>
                                    <Option value={4}>YD</Option>
                                    <Option value={5}>MX</Option>
                                    <Option value={6}>M7</Option>
                                    <Option value={7}>Y8</Option>
                                    <Option value={8}>P4</Option>
                                    <Option value={9}>tT</Option>
                                    <Option value={10}>Mogo</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务来源">
                            {getFieldDecorator('taskSource', {
                                initialValue: this.state.taskSource,
                            })(
                                <RadioGroup onChange={this.changeTaskSource}>
                                    <Radio value={'ifengad'}>IFENGAD</Radio>
                                    <Radio value={'dmp'}>DMP</Radio>
                                    <Radio value={'api'}>API</Radio>
                                    <Radio value={'dol'}>传漾</Radio>
                                    <Radio value={'accurateOperations'}>精准运营</Radio>
                                    <Radio value={'lookalike'}>追投</Radio>
                                    <Radio value={'js'}>脚本投放</Radio>
                                    <Radio value={'brandDsp'}>brandDsp</Radio>
                                    {/* <Radio value={'applaunch'}>APP拉起</Radio> */}
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="app包名">
                                {getFieldDecorator('packageName', {})(<Input />)}
                            </FormItem>
                        {/* {this.state.taskType == 'APPLAUNCH' || this.state.taskType == 'APP_RETAIN' ? (
                            <FormItem {...formItemLayout} label="app包名">
                                {getFieldDecorator('packageName', {})(<Input />)}
                            </FormItem>
                        ) : null} */}
                        <FormItem {...formItemLayout} label="留存比例">
                            {getFieldDecorator('retainRatio', {
                                initialValue: 0,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的留存比例',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="是否获取素材">
                                {getFieldDecorator('requestElement', {
                                    initialValue: 0,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>开启</Radio>
                                        <Radio value={1}>关闭</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投任务Id">
                                {getFieldDecorator('lookalikeTaskId', {})(<Input />)}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投订单Id">
                                {getFieldDecorator('lookalikeOrderId', {})(<Input />)}
                            </FormItem>
                        ) : null}
                        <FormItem {...formItemLayout} label="设备Id利用次数">
                            {getFieldDecorator('deviceIdReusedTimes', {
                                initialValue: this.state.deviceIdReusedTimes,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确利用次数',
                                    },
                                ],
                            })(<Input style={{ width: '50%' }} />)}
                            {getFieldDecorator('deviceIdDiffByTaskOrEid', {
                                initialValue: null

                            })(
                                <Select allowClear placeholder="控制域" style={{ width: '50%' }}>
                                    <Option value={0}>根据taskId</Option>
                                    <Option value={1}>根据eId</Option>
                                    <Option value={2}>用完即删</Option>
                                    <Option value={3}>按周控制</Option>
                                    <Option value={4}>根据广告位</Option>
                                    <Option value={5}>联合控制</Option>
                                    <Option value={6}>只用历史号</Option>
                                    <Option value={7}>历史号最低频次</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投标签">
                                {getFieldDecorator('lookalikeTag', {})(<Input />)}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="API">
                                {getFieldDecorator('api', {
                                    rules: [
                                        {
                                            //pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                                            required: false,
                                            message: '请输入api',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                        //     <FormItem {...formItemLayout} label="是否回传">
                        //     {getFieldDecorator('passBack', {
                        //         initialValue: "",
                        //     })(
                        //         <RadioGroup>
                        //             <Radio value={0}>是</Radio>
                        //             <Radio value={1}>否</Radio>
                        //         </RadioGroup>,
                        //     )}
                        // </FormItem>
                        <FormItem {...formItemLayout} label="点击回传">
                            {getFieldDecorator('isClickPassBack', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        ) : null}
                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="曝光回传">
                            {getFieldDecorator('isEvPassBack', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        ) : null}

                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="是否串行">
                            {getFieldDecorator('isBunchExecute', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        ) : null}

                        {(this.state.taskSource == 'api' ||this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike')  ? (
                            <FormItem {...formItemLayout} label="是否首条先执行">
                                {getFieldDecorator('isFirstExecute', {
                                    initialValue: null,
                                })(
                                    <RadioGroup >
                                        <Radio value={1}>是</Radio>
                                        <Radio value={0}>否</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                        ) : null}

                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="素材是否使用真实ip">
                            {getFieldDecorator('isApiMaterialUseRealIp', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={1}>是</Radio>
                                    <Radio value={0}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        ) : null}

                        {this.state.taskSource == 'api' ||
                        this.state.taskSource == 'accurateOperations' ||
                        this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="时间间隔">
                                {getFieldDecorator('evClickIntervalTime', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="兴趣">
                                {getFieldDecorator('interest', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '至少选择一个标签',
                                        },
                                    ],
                                })(
                                    <Select
                                        multiple
                                        placeholder="兴趣"
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                        {labelList
                                            .filter((label, index) => {
                                                return label.type == 'i';
                                            })
                                            .map((label, index) => {
                                                return (
                                                    <Option key={label.id} title={label.labelName} value={label.id}>
                                                        {label.labelName}
                                                    </Option>
                                                );
                                            })}
                                    </Select>,
                                )}
                            </FormItem>
                        ) : null}
                        {this.state.taskSource == 'accurateOperations' || this.state.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="用户信息">
                                {getFieldDecorator('userInfo', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '至少选择一个标签',
                                        },
                                    ],
                                })(
                                    <Select
                                        multiple
                                        placeholder="用户信息"
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                        {labelList
                                            .filter((label, index) => {
                                                return label.type == 's';
                                            })
                                            .map((label, index) => {
                                                return (
                                                    <Option key={label.id} title={label.labelName} value={label.id}>
                                                        {label.labelName}
                                                    </Option>
                                                );
                                            })}
                                    </Select>,
                                )}
                            </FormItem>
                        ) : null}
                       
                        <FormItem {...formItemLayout} label="设备类型">
                            {getFieldDecorator('deviceInfo', {
                                initialValue: this.state.deviceInfo,
                                rules: [{ message: '请选择设备类型' }],
                            })(
                                <Select onChange={this.handleChangeDeviceInfo.bind(this)}>
                                    <Option value="DEFAULT">默认</Option>
                                    <Option value="ANDROID">安卓</Option>
                                    <Option value="IPHONE">IOS</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {/* <FormItem {...formItemLayout} label="安卓占比">
                            {getFieldDecorator('androidRatio', {
                                initialValue: this.state.androidRatio,
                            })(<Slider marks={marks} min={0} max={10} />)}
                        </FormItem> */}
                        <FormItem {...formItemLayout} label="安卓占比">
                                {getFieldDecorator('androidRatio', {
                                    initialValue: this.state.androidRatio,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '格式不正确',
                                        },
                                    ],
                                })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="平台">
                            {getFieldDecorator('platform', {
                                initialValue: 'PC',
                                rules: [{ message: '请选择设备类型' }],
                            })(
                                <Select>
                                    <Option value="APP">APP</Option>
                                    <Option value="WAP">WAP</Option>
                                    <Option value="PC">PC</Option>
                                    <Option value="OTT">OTT</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="曲线基准">
                            {getFieldDecorator('curve', {
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                                <Select allowClear placeholder="曲线基准" style={{ width: 200 }}>
                                    {curveList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                                /*<Select
                                    multiple
                                    placeholder="曲线基准"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {curveList.length > 0 ? curveList.map((label, index) => {
                                        return <Option key={label} title={label} value={label}>{label}</Option>
                                    }) : null}
                                </Select>*/
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="结束方式">
                            {getFieldDecorator('endType', {
                                initialValue: null
                            })(
                                <Select placeholder="结束方式" style={{ width: '50%' }}>
                                    <Option value={0}>无</Option>
                                    <Option value={1}>到量即止</Option>
                                    <Option value={2}>无填充</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {/* <FormItem {...formItemLayout} label="广告位置">
                            {getFieldDecorator('taskPosition', {
                                initialValue: 'DEFAULT',
                                rules: [{ message: '请选择广告位置' }],
                            })(
                                <Select onChange={this.changeTaskPosition}>
                                    <Option value="DEFAULT">默认</Option>
                                    <Option value="TOP">首页</Option>
                                    <Option value="BOTTOM">底部</Option>
                                </Select>,
                            )}
                        </FormItem> */}
                        <FormItem {...formItemLayout} label="URL">
                            {getFieldDecorator('url', {
                                // rules: [
                                //     {
                                //         pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                                //         required: true,
                                //         message: '请输入url',
                                //     },
                                // ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="强制到达">
                            {getFieldDecorator('forceArrive', {
                                initialValue: 0,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="指定代理商">
                            {getFieldDecorator('appointProxyName', {
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {agents.map((item, index) => {
                                        return (
                                            <Option key={index} title={item} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="排除代理商">
                            {getFieldDecorator('excludeProxyName', {
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="排除-代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {agents.map((item, index) => {
                                        return (
                                            <Option key={index} title={item} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        
                        <FormItem {...formItemLayout} label="独享代理池">
                            {getFieldDecorator('exclusiveProxy', {
                                initialValue: 0,
                            })(
                                // <RadioGroup>
                                //     <Radio value={0}>关闭</Radio>
                                //     <Radio value={1}>开启</Radio>
                                // </RadioGroup>,
                                <Select>
                                 <Option value={0}>关闭</Option>
                                 <Option value={1}>开启(taskId)</Option>
                                 <Option value={2}>开启(eId)</Option>
                               </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="总量控制">
                            {getFieldDecorator('tc', {
                                initialValue: 1,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="忽略阻塞限制">
                            {getFieldDecorator('ignoreThreshold', {
                                initialValue: 0,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="分配方式">
                            {getFieldDecorator('onTargetPv', {
                                initialValue: 0,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>余量分配</Radio>
                                    <Radio value={1}>总量分配</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="禁用图片">
                            {getFieldDecorator('disableImg', {
                                initialValue: 0,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否追投">
                            {getFieldDecorator('isAdditional', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>按设备ID</Radio>
                                    <Radio value={2}>按IP</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否重写Canvas">
                            {getFieldDecorator('isOverwriteCanvas', {
                                initialValue: null,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="目标量">
                            {getFieldDecorator('targetPv', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确目标量',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="溢出量">
                            {getFieldDecorator('overflowRate', {
                                initialValue: this.state.overflowRate,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入溢出量',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(
                                <RadioGroup onChange={this.changeFlow}>
                                    <Radio value={10}>10%</Radio>
                                    <Radio value={20}>20%</Radio>
                                    <Radio value={30}>30%</Radio>
                                    <Radio value={40}>自定义</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        {this.state.overflowRate == 40 ? (
                            <FormItem {...formItemLayout} label="自定义溢出比例">
                                {getFieldDecorator('overflow', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请输入溢出量百分比，如10',
                                            //pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input placeholder="请填入比例，如10" />)}
                            </FormItem>
                        ) : null}
                        
                        <FormItem {...formItemLayout} label="溢出标准值">
                            {getFieldDecorator('standardOverflowRate', {
                                rules: [
                                    {
                                        required: false,
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input style={{width:'20%'}} />)}
                            &nbsp;&nbsp;&nbsp;down:&nbsp;
                            {getFieldDecorator('reduceFlowRate',{})(<Input style={{width:'20%'}} />
                            )}&nbsp;up:&nbsp;
                            {getFieldDecorator('addFlowRate', {})(<Input style={{width:'20%'}} />
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="ivt阈值">
                            {getFieldDecorator('ivt', {
                                initialValue: 0,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确ivt阈值',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input style={{ width: '50%' }} />)}
                            {getFieldDecorator('realTimeIvt', {
                                initialValue: this.state.realTimeIvt,
                            })(
                                <Select allowClear placeholder="是否实时" style={{ width: '50%' }}>
                                    <Option value={0}>不实时</Option>
                                    <Option value={1}>实时</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="启用截图">
                            {getFieldDecorator('screenshots', {
                                initialValue: 0,
                            })(
                                <RadioGroup>
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="定向省份">
                            {getFieldDecorator(
                                'provinces',
                                /*, {
                                initialValue: [0],
                                rules: [
                                    {
                                        required: true,
                                        message: '至少选择一个',
                                    },
                                ],
                            }*/
                            )(
                                <Select
                                    multiple
                                    placeholder="投放省份"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {provinceList.map((province, index) => {
                                        return (
                                            <Option key={province.id} title={province.name} value={province.id}>
                                                {province.name}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="非定向省份">
                            {getFieldDecorator(
                                'excludeProvinces',
                                /*, {
                                    initialValue: [0],
                                    rules: [
                                        {
                                            required: true,
                                            message: '至少选择一个',
                                        },
                                    ],
                                }*/
                            )(
                                <Select
                                    multiple
                                    placeholder="非投放省份"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    {provinceList.map((province, index) => {
                                        return (
                                            <Option key={province.id} title={province.name} value={province.id}>
                                                {province.name}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="所属集群">
                            {getFieldDecorator('belongCluster', {
                                initialValue: clusterList.length > 0 ? clusterList[0] : '',
                            })(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {clusterList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item}>
                                                {item}
                                            </Option>
                                        );
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="启用时间">
                            <div>
                                <div style={{ width: 290, border: '1px solid #d9d9d9', borderRadius: 4 }}>
                                    {getFieldDecorator('filtration', {
                                        initialValue: moment(today, 'YYYY-MM-DD'),
                                        rules: [{ required: true, message: '请选择过滤时间' }],
                                    })(
                                        <Calendar
                                            fullscreen={false}
                                            onSelect={this.selectData.bind(this)}
                                            dateCellRender={this.dateCellRender}
                                        />,
                                    )}
                                </div>

                                <div className="selectedData">
                                    {this.state.filtration.map((v, k) => {
                                        return (
                                            <span>
                                                {v}
                                                <o
                                                    onClick={() => {
                                                        this.removeData(k);
                                                    }}>
                                                    x
                                                </o>
                                            </span>
                                        );
                                    })}
                                </div>
                            </div>
                        </FormItem>

                        <FormItem {...formItemLayout} label="时间段">
                            {/* {getFieldDecorator('beginTime', {
                                initialValue: moment(this.state.beginTime, 'HH:mm'),
                                rules: [{ type: 'object', require: true, message: '请选择时间段' }],
                            })(<TimePicker format="HH:mm" />)}
                            {getFieldDecorator('endTime', {
                                initialValue: moment(this.state.endTime, 'HH:mm'),
                                rules: [{ type: 'object', require: true, message: '请选择时间段' }],
                            })(<TimePicker format="HH:mm" style={{ padding: '0 0 0 10px' }} />)} */}
                            {getFieldDecorator('timePairs', {
                                initialValue: [
                                    {
                                        beginTime: parseInt(this.state.beginTime.replace((':': ''))),
                                        endTime: parseInt(this.state.endTime.replace((':': ''))),
                                    },
                                ],
                            })(<TimePairsSelect />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="PV频次及占比">
                            {getFieldDecorator('pvDistributeEntities', {
                                initialValue: [
                                    {
                                        pvc: this.state.pvc,
                                        ratio: this.state.ratio,
                                    },
                                ],
                            })(<PvcRatio />)}
                        </FormItem>


                        <div style={{ display: this.state.role == 1 ? 'block' : 'none' }}>
                            <FormItem {...formItemLayout} label="等待时长（s）">
                                {getFieldDecorator('waitTimeout', {
                                    initialValue: this.state.waitTimeout,
                                    rules: [
                                        {
                                            message: '请输入正确等待时长（s）',
                                            pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            {/* <FormItem {...formItemLayout} label="强制等待">
                                {getFieldDecorator('forceWait', {
                                    initialValue: 0,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem> */}
                            <FormItem {...formItemLayout} label="代理有效时长">
                                {getFieldDecorator('forceWait', {
                                    initialValue: this.state.forceWait,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入代理有效时长数值',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="UV占比">
                                {getFieldDecorator('pvToUvRatio', {
                                    initialValue: this.state.pvToUvRatio,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确UV占比',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="利用次数">
                                {getFieldDecorator('ipReusedTimes', {
                                    initialValue: this.state.ipReusedTimes,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确利用次数',
                                        },
                                    ],
                                })(<Input style={{ width: '50%' }} />)}
                                {getFieldDecorator('ipDiffByTaskOrEid', {
                                    initialValue: this.state.ipDiffByTaskOrEid,
                                })(
                                    <Select allowClear placeholder="控制域" style={{ width: '50%' }}>
                                        <Option value={0}>根据taskId</Option>
                                        <Option value={1}>根据eId</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ip使用范围">
                                {getFieldDecorator('ipRange', {
                                    initialValue: '全部ip',
                                })(
                                    <Select>
                                        <Option value="0">全部ip</Option>
                                        <Option value="1">去除黑名单ip</Option>
                                        <Option value="2">IP地域过滤</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ip利用次数单位时间">
                                {getFieldDecorator('ipInterval', {
                                    initialValue: this.state.ipInterval,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的单位时间',
                                        },
                                    ],
                                })(<InputNumber />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="单位时间ip利用次数">
                                {getFieldDecorator('ipUnitReuseTimes', {
                                    rules: [
                                        {
                                            required: this.state.ipInterval != 0 ? true : false,
                                            pattern: /^\d+$/,
                                            message: '请输入正确的ip利用次数',
                                        },
                                    ],
                                })(<InputNumber />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="引擎">
                                {getFieldDecorator('engine', {
                                    initialValue: 'PHANTOMJS',
                                })(
                                    <Select onChange={this.handleEngine.bind(this)} style={{ width: 200 }}>
                                        <Option value="PHANTOMJS">PhantomJS</Option>
                                        <Option value="CHROME">Chrome</Option>
                                        <Option value="CHROMIUM">Chromium</Option>
                                        <Option value="APP">App</Option>
                                        <Option value="APPLAUNCH">AppLaunch</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="主脚本地址">
                                {getFieldDecorator('mainScriptPath', {
                                    initialValue: '',
                                    rules: [{ required: true, message: '请选择类型' }],
                                })(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {primaryScripts
                                            .filter((item, index) => {
                                                let engine = this.state.engine;
                                                if (engine === 'CHROMIUM') {
                                                    engine = 'CHROME';
                                                }
                                                return item.source == engine;
                                            })
                                            .map((item, index) => {
                                                return (
                                                    <Option key={index} value={item.path}>
                                                        {item.name}
                                                    </Option>
                                                );
                                            })}
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="脚本地址">
                                {getFieldDecorator('scriptPath', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            // required: this.state.taskPosition == 'DEFAULT' ? false : true,
                                            required: false,
                                            message: '请输入脚本地址',
                                        },
                                    ],
                                })(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {otherScripts
                                            .filter((item, index) => {
                                                let engine = this.state.engine == 'PHANTOMJS' ? 'PHANTOMJS' : 'CHROME';
                                                return item.source == engine;
                                            })
                                            .map((item, index) => {
                                                return (
                                                    <Option key={index} value={item.path}>
                                                        {item.name}
                                                    </Option>
                                                );
                                            })}
                                    </Select>,
                                )}
                            </FormItem>

                            <FormItem {...formItemLayout} label="客户端分组id">
                                {getFieldDecorator('groupId', {
                                    initialValue: this.state.groupId,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的分组id',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="异步请求">
                                {getFieldDecorator('isAsynRequest', {
                                    initialValue: null,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="强制互动">
                                {getFieldDecorator('forceInteraction', {
                                    initialValue: 0,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="检测公司预警">
                                {getFieldDecorator('interactionAlarm', {
                                    initialValue: 0,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="自动修改溢出">
                                {getFieldDecorator('autoUpdateOverFlowRate', {
                                    initialValue: 0,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>禁用</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="执行脚本">
                                {getFieldDecorator('executeScript')(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="脚本互动比例">
                                {getFieldDecorator('shellProportion', {
                                    initialValue: this.state.shellProportion,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的脚本互动比例',
                                        },
                                    ],
                                })(<Input addonAfter="%" />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="referer">
                                {getFieldDecorator('referer', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            message: '请输入referer',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="完成标记">
                                {getFieldDecorator('finishedFlag', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            message: '请输入完成标记',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="请求类型">
                                {getFieldDecorator('requestType', {
                                    initialValue: 'WEBKIT',
                                })(
                                    <Select>
                                        <Option value="WEBKIT">WEBKIT</Option>
                                        <Option value="HTTP_CLIENT">HTTP_CLIENT</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            {/* <FormItem {...formItemLayout} label="行为数据">
                                {getFieldDecorator('behaviourData', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            message: '请输入行为数据',
                                        },
                                    ],
                                })(<TextArea />)}
                            </FormItem> */}
                            <Row style={{ position: 'relative' }} gutter={2} style={{ marginBottom: '20px' }}>
                                <Col span={6} style={{ fontSize: '12px', lineHeight: '32px', textAlign: 'right' }}>
                                    请输入行为数据：
                                </Col>
                                <Col span={14}>
                                    <TextArea value={this.state.behaviourData} onChange={this.changeBehaviourData} />
                                </Col>
                                <Col span={2} style={{ marginLeft: '6px' }}>
                                    <Button type="danger" onClick={this.showBehaviourEdit}>
                                        转换
                                    </Button>
                                </Col>
                            </Row>
                            <FormItem {...formItemLayout} label="行为互动比例">
                                {getFieldDecorator('activeProportion', {
                                    initialValue: this.state.activeProportion,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的行为互动比例',
                                        },
                                    ],
                                })(<Input addonAfter="%" />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="互动执行延时">
                                {getFieldDecorator('behaviourDataWaitTime', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="监测代码请求期望数">
                                {getFieldDecorator('irCountExcept', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="关联taskId">
                                {getFieldDecorator('connectTaskIds', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            message: '关联taskId',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="执行速度系数">
                                {getFieldDecorator('speedRatio', {
                                    initialValue: null,
                                })(
                                    <Select>
                                        <Option value={40}>40%</Option>
                                        <Option value={60}>60%</Option>
                                        <Option value={80}>80%</Option>
                                        <Option value={100}>100%</Option>
                                        <Option value={120}>120%</Option>
                                        <Option value={140}>140%</Option>
                                        <Option value={160}>160%</Option>
                                        <Option value={180}>180%</Option>
                                        <Option value={200}>200%</Option>
                                        <Option value={220}>220%</Option>
                                        <Option value={240}>240%</Option>
                                        <Option value={260}>260%</Option>
                                        <Option value={280}>280%</Option>
                                        <Option value={300}>300%</Option>
                                        <Option value={500}>500%</Option>
                                        <Option value={800}>800%</Option>
                                        <Option value={1000}>1000%</Option>
                                        <Option value={2000}>2000%</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="追踪取样比例(%)">
                                {getFieldDecorator('trackingSamplingRatio', {
                                    initialValue: null,
                                    rules: [
                                        {
                                            message: '取值为0-100',
                                            pattern: /^(?:[1-9]?\d|100)$/,
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="点击率">
                                {getFieldDecorator('clickRate', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="点击率分组">
                                {getFieldDecorator('clickRateFlag', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="任务关联关键字">
                                {getFieldDecorator('connectKey', {
                                    initialValue: '',
                                })(
                                    <Select>
                                        <Option value="splash_gdt">splash_gdt</Option>
                                        <Option value="splash_csj">splash_csj</Option>
                                        <Option value="banner_gdt">banner_gdt</Option>
                                        <Option value="banner_csj">banner_csj</Option>
                                        <Option value="flow_gdt">flow_gdt</Option>
                                        <Option value="flow_csj">flow_csj</Option>
                                        <Option value="pop_gdt">pop_gdt</Option>
                                        <Option value="pop_csj">pop_csj</Option>
                                        <Option value="">空</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="到达率">
                                {getFieldDecorator('hzArrivalRate', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="附加信息">
                                {getFieldDecorator('dependentType', {
                                    initialValue: '',
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否回传安卓id">
                                {getFieldDecorator('isAndroidIdPassBack', {
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否回传Mac">
                                {getFieldDecorator('isMacPassBack', {
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否回传oaId">
                                {getFieldDecorator('isOaIdPassBack', {
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="素材格式预警">
                                {getFieldDecorator('materialFormatWarning', {
                                    initialValue: 0,
                                })(
                                    <Select>
                                        <Option value={0}>关闭</Option>
                                        <Option value={1}>打开</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="期望溢出">
                                {getFieldDecorator('expectOverFlow', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="检测公司">
                                {getFieldDecorator('monitorNames', {
                                    rules: [
                                        {
                                            required: false,
                                            message: '至少选择一个标签',
                                        },
                                    ],
                                })(
                                    <Select
                                        multiple
                                        placeholder="检测公司"
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }>
                                        {moniterNameList.map((label, index) => {
                                            return (
                                                <Option
                                                    key={label.monitoringName}
                                                    title={label.monitoringName}
                                                    value={label.monitoringName}>
                                                    {label.monitoringName}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="任务组">
                                {getFieldDecorator('creatorGroupId', {
                                    initialValue: groupList.length > 0 ? groupList[0]._id : '',
                                })(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {groupList.map((item, index) => {
                                            return (
                                                <Option key={index} value={item._id}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="责任人">
                                {getFieldDecorator('principal', {
                                    initialValue: '',
                                })(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {userList.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.name}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </div>
                    </Form>
                </Modal>
                <BehaviourMask
                    behaviourData={this.state.behaviourData}
                    editBehavior={editBehavior}
                    hideBehaviorMask={this.hideBehaviorMask}
                    changeEditInfo={this.changeEditInfo}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ListLoading: state.tasklist.ListStatus.loading,
    taskList: state.tasklist.List,
    taskId: state.tasklist.TaskId,
    root: state.tasklist.Root,
    parentId: state.tasklist.ParentId,
    addStatus: state.tasklist.ListStatus.addShow,
    addType: state.tasklist.ListStatus.addType,
    provinceList: state.tasklist.ProvinceList,
    labelList: state.tasklist.LabelList,
    moniterNameList: state.tasklist.moniterNameList,
    curveList: state.tasklist.curveList,
    primaryScripts: state.tasklist.primaryScripts,
    otherScripts: state.tasklist.otherScripts,
    clusterList: state.tasklist.ClusterList,
    outTaskCategoryList: state.tasklist.OutTaskCategoryList,
    groupList: state.tasklist.GroupList,
    agents: state.tasklist.agents,
    userList: state.tasklist.UserList, //用户列表
    accountList: state.tasklist.accountList,
});

const mapDispatchToProps = dispatch => ({
    getList: param => dispatch(getList(param)),
    getTaskId: () => dispatch(getTaskId()),
    changeAddStatus: status => dispatch(createAddShowAction(status)),
    toSubmit: param => dispatch(submitToMD(param)),
    toInsert: param => dispatch(insertToMD(param)),
    getProvinceList: () => dispatch(getProvinceList()),
    getLabelList: () => dispatch(getLabelList()),
    getCurveList: () => dispatch(getCurveList()),
    getScripts: () => dispatch(getPrimaryAndOtherScript()),
    getClusterList: () => dispatch(getClusterList()),
    getOutTaskCategoryList: () => dispatch(getOutTaskCategoryList()),
    getGroupList: () => dispatch(getGroupList()),
    getAgentsAndAreas: () => dispatch(getAgentsAndAreas()),
    getUserList: () => dispatch(getUserList()),
    getMonitorList: () => dispatch(getMonitorList()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Form.create()(AddTask));



// WEBPACK FOOTER //
// ./pages/task/tasklist/add.js